import { apiClient } from './client';

// Integration events held back for a human decision. Today that means a duplicate supplier
// invoice: the event is valid, but posting it would admit a second liability for a reference
// that already exists. Not an error and not retryable — it waits for Discard or Override.
export interface QuarantinedEvent {
  eventId: string;
  eventType: string;
  sourceSystem: string;
  sourceDocumentNumber?: string | null;
  businessDate: string;
  currencyCode?: string | null;
  reason: string;
  receivedAt: string;
}

export const quarantineApi = {
  async list(): Promise<QuarantinedEvent[]> {
    const r = await apiClient.get('/integration/events/quarantined');
    return r.data?.data ?? [];
  },
  /** Events myLedger refused (no rule, unmapped account, closed period…), with the reason. Same shape. */
  async listFailed(): Promise<QuarantinedEvent[]> {
    const r = await apiClient.get<{ data?: QuarantinedEvent[] }>('/integration/events/failed');
    return r.data?.data ?? [];
  },
  /** Post a failed event again once its cause is fixed. */
  async retry(eventId: string): Promise<void> {
    await apiClient.post(`/integration/events/${eventId}/retry`);
  },
  /** Never post it. Terminal — the source outbox row stays consumed, so it is not re-sent. */
  async discard(eventId: string, reason: string): Promise<void> {
    await apiClient.post(`/integration/events/${eventId}/discard`, { reason });
  },
  /** Post despite the duplicate. Creates a SECOND liability for the same reference — deliberate. */
  async overrideDuplicate(eventId: string, reason: string): Promise<void> {
    await apiClient.post(`/integration/events/${eventId}/override-duplicate`, { reason });
  },
};
